import { defineStore } from 'pinia';

export default defineStore('device', () => {
  const deviceId = ref();
  const deviceToken = ref();

  const hasDeviceId = computed((): boolean => {
    return !!deviceId.value;
  });

  const hasDeviceToken = computed((): boolean => {
    return !!deviceToken.value;
  });

  const resetDevice = (): void => {
    deviceId.value = null;
    deviceToken.value = null;
  };

  return {
    deviceId,
    deviceToken,

    hasDeviceId,
    hasDeviceToken,

    resetDevice,
  };
});
